import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { ApiV1_ProductTag } from '@pedix-workspace/api-v1';
import { AppRequestContextService } from 'apps/pedixapp/src/app/app-request-context.service';

export const productsTagResolverFn: ResolveFn<ApiV1_ProductTag> = (
  routeSnapshot: ActivatedRouteSnapshot,
) => {
  const appRequestContext = inject(AppRequestContextService);
  const platformId = inject(PLATFORM_ID);

  // NOTE: tag id is in search query params, which is not available on SSR; resolver will be executed again on the browser
  if (isPlatformServer(platformId)) {
    return null;
  }

  const { t: tagId } = routeSnapshot.queryParams;

  return appRequestContext.productTags().find(productTag => {
    return tagId === productTag.id || tagId === productTag.slug;
  });
};
